module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lgJio"))).then(() => parcelRequire('hEqeo'));